<template>
  <div class="admin-users">
    <header-title title="Usuarios administradores"></header-title>

    <div class="product-btn">
      <v-btn
        dense
        outlined
        @click="openUserDialog('addUser')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>
    </div>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <div class="page-title">
      <v-container class="pl-0 pr-0">
        <v-row class="filters" justify="center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-text-field
              outlined
              dense
              label="Buscar Usuario"
              v-model="search"
              class="select-box"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-select
              v-model="selectedRole"
              :items="filterRoleDropdown"
              item-text="label"
              item-value="value"
              label="Roles"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-row v-if="serverUsers">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="sortedUsers"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.roles`]="{ item }">
            <template v-for="role in item.roles">
              <div :key="role">
                <v-chip class="ma-2" color="primary" x-small>
                  {{ getRoleLabel(role) }}
                </v-chip>
              </div>
            </template>
          </template>
          <template v-slot:[`item.enabled`]="{ item }">
            <div style="display:flex;">
              {{ item.loading }}
              <v-switch
                v-model="item.enabled"
                @change="updateStatus(item, index)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openUserDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <UserDialog :users="users" ref="userDialog"></UserDialog>
  </div>
</template>

<script>
import moment from "moment";
import { orderBy } from "lodash";
import Loader from "../../../components/common/Loader";
import UserDialog from "../../../components/admin/user/UserDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { UsersTableHeader } from "@/utils/tableHeaderconstants";
import { usersCollection } from "@/collections/users";

const USER_ROLES = {
  all: "Todos",
  MANAGER: "Encargado",
  OWNER: "Propietario",
  WAITER: "Camarero"
};

export default {
  name: "users",
  components: { Loader, UserDialog, HeaderTitle },
  data() {
    return {
      email: "",
      name: "",
      search: "",
      headers: [...UsersTableHeader],
      selectedRole: "all",
      users: [],
      serverUsers: null,
      filterRoleDropdown: [
        {
          label: USER_ROLES["all"],
          value: "all"
        },
        {
          label: USER_ROLES["MANAGER"],
          value: "MANAGER"
        },
        {
          label: USER_ROLES["OWNER"],
          value: "OWNER"
        },
        {
          label: USER_ROLES["WAITER"],
          value: "WAITER"
        }
      ],
      dialogLoader: true
    };
  },
  firestore() {
    return {
      users: usersCollection
    };
  },
  computed: {
    sortedUsers() {
      let _users = [...this.users];
      let orderedUsers = _users
        ? orderBy(
            _users,
            o => {
              return moment(
                o.updated_on ||
                  moment()
                    .subtract(1, "M")
                    .format()
              );
            },
            ["desc"]
          )
        : [];

      orderedUsers.map(user => {
        if (!user.email) user.email = "";
        return user;
      });

      return orderedUsers.filter(x => {
        let check =
          x.email.toLowerCase().includes(this.email.toLowerCase()) &&
          x.name.toLowerCase().includes(this.name.toLowerCase());

        if (this.selectedRole !== "all") {
          return check && x.roles.includes(this.selectedRole);
        }

        return check;
      });
    }
  },
  async mounted() {
    this.listFirebaseUsers();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async updateStatus(user, index) {
      let data = {
        uid: user.id,
        disabled: !user.enabled
      };
      try {
        await this.$api.admin.updateFirebaseUser(data);
      } catch (error) {
        this.showErrorMessage(error.message);
      }
    },
    async listFirebaseUsers() {
      try {
        let data = await this.$api.admin.listFirebaseUsers();
        this.serverUsers = data.users;
        // eslint-disable-next-line no-unused-vars
        this.users.forEach((localUser, index) => {
          let foundUser = data.users.find(x => x.uid === localUser.id);
          localUser.enabled = !foundUser.disabled;
        });

        this.dialogLoader = false;
      } catch (error) {
        this.dialogLoader = false;
        this.showErrorMessage(error.message);
      }
    },
    getRoleLabel(role) {
      return USER_ROLES[role];
    },
    openUserDialog(id) {
      this.$refs.userDialog.open(id);
    }
  }
};
</script>

<style></style>
